class Category {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    // eslint-disable-next-line eqeqeq
    this.is_enabled = data ? (data.is_enabled == 1) : false
    // eslint-disable-next-line eqeqeq
    this.is_menu_top = data ? (data.is_menu_top == 1) : false
    this.sort_no = data ? data.sort_no : null
    this.thumbnail = data ? data.thumbnail : null
    this.thumbnailUrl = data ? data.thumbnailUrl : null
  }
}

export default Category



// WEBPACK FOOTER //
// ./src/models/Category.js